import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("h5", { staticClass: "title-section" }, [
                _vm._v("List Divisions"),
              ]),
              _c("br"),
              _c(
                "b-button",
                {
                  staticClass: "ml-1",
                  attrs: {
                    size: "sm",
                    variant: "outline-primary",
                    title: "Update Data",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onOpenNew()
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "plus" } }),
                  _c("span", [_vm._v("New")]),
                ],
                1
              ),
              _c("br"),
              _c("b-table", {
                style: { "font-size": "11px" },
                attrs: {
                  id: "tbl-plan-data",
                  fields: _vm.fields,
                  items: _vm.items,
                  responsive: "",
                  "sticky-header": true,
                  hover: "",
                  "per-page": _vm.pagination.limit,
                  "current-page": _vm.pagination.current,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(creation_date)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.item.update_date || row.item.creation_date
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(creation_user)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.item.update_user || row.item.creation_user
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(action)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-modal", {
        ref: "my-modal-plan-data",
        attrs: {
          id: "my-modal-plan-data",
          size: "md",
          title: "Demo",
          "hide-footer": "",
          "no-close-on-backdrop": true,
          "no-close-on-esc": true,
        },
        scopedSlots: _vm._u([
          {
            key: "modal-title",
            fn: function () {
              return [
                _vm._v(
                  _vm._s(_vm.new_item.id ? "Edit" : "Create") + " Division"
                ),
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Name :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { size: "sm", disabled: _vm.readonly },
                                model: {
                                  value: _vm.new_item.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.new_item, "name", $$v)
                                  },
                                  expression: "new_item.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Definition :",
                                "label-cols": "4",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { size: "sm", disabled: _vm.readonly },
                                model: {
                                  value: _vm.new_item.definition,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.new_item, "definition", $$v)
                                  },
                                  expression: "new_item.definition",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { sm: "12", lg: "12" } }, [
                      _c("div", { staticClass: "mt-3 row" }, [
                        _c(
                          "div",
                          { staticClass: "float-rigth col-12" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2",
                                attrs: { size: "sm" },
                                on: { click: _vm.onCancel },
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "material-icons md-16" },
                                  [_vm._v("cancel")]
                                ),
                                _c("span", [_vm._v("Cancel")]),
                              ]
                            ),
                            _c(
                              "b-button",
                              {
                                staticClass: "active ml-2",
                                attrs: { size: "sm", variant: "primary" },
                                on: { click: _vm.onSaveDivision },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("mdi-check-circle-outline"),
                                ]),
                                _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }